var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',[_c('div',{staticClass:"display-4 headline"},[_vm._v("Page Not Found")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }